import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class Configuration {
    public appSettings: any;
    public baseServerURL: any;

    constructor() {
        this.baseServerURL = '/api/v1/';

        if (environment.mode == 'local') {
            this.baseServerURL = 'https://localhost:44368/api/v1/';
        }
    }
}